<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-title>
        <div class="row">
          <h5 class="card-title col-md-6">Consultar</h5>
          <div class="d-flex justify-content-end col-md-6">
            <router-link to="veiculo/add">
              <button class="btn btn-info" type="button">
                <i
                  class="mdi mdi-plus-circle-outline font-size-16 align-middle me-2"
                ></i
                >Novo Veículo
              </button>
            </router-link>
          </div>
        </div>
      </b-card-title>

      <div class="row">
        <b-form-group
          label="Locadora"
          invalid-feedback="campo obrigatório"
          class="col-md-4 mb-3"
          :state="state('cd_pessoa')"
        >
          <multiselect
            v-model="selectFiltro.pessoa"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionEmpresa"
            @input="carregaPessoa()"
            :custom-label="
              ({ nm_fantasia, nr_cgc_cpf }) =>
                `${nm_fantasia} [${$tools.converterCnpj(nr_cgc_cpf)}]`
            "
          />
        </b-form-group>
        <b-form-group
          label="Placa"
          invalid-feedback="campo obrigatório"
          class="col-md-3 mb-3"
        >
          <multiselect
            v-model="dadosFiltro.nr_placa"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionPlaca"
          />
        </b-form-group>
        <b-form-group
          label="Marca"
          invalid-feedback="campo obrigatório"
          class="col-md-5 mb-3"
        >
          <multiselect
            v-model="selectFiltro.marca"
            placeholder="Selecione"
            label="nm_marca"
            track-by="cd_marca"
            :show-labels="false"
            :options="optionMarca"
            @input="carregaMarca()"
          />
        </b-form-group>
        <b-form-group
          label="Categoria"
          invalid-feedback="campo obrigatório"
          class="col-md-4 mb-3"
        >
          <multiselect
            v-model="selectFiltro.categoria"
            placeholder="Selecione"
            track-by="cd_categoria"
            label="nm_categoria"
            :show-labels="false"
            :options="optionCategoria"
            @input="carregaCategoria()"
          />
        </b-form-group>

        <b-form-group
          label="Modelo"
          invalid-feedback="campo obrigatório"
          class="col-md-3 mb-3"
        >
          <multiselect
            v-model="selectFiltro.modelo"
            placeholder="Selecione"
            label="nm_modelo"
            :show-labels="false"
            track-by="sq_modelo"
            :options="optionModelo"
            @input="carregaModelo()"
          />
        </b-form-group>

        <b-form-group
          label="Ano"
          invalid-feedback="campo obrigatório"
          class="col-md-2"
        >
          <date-picker
            v-model="dadosFiltro.dt_ano_fabricacao"
            placeholder="Selecione"
            type="year"
            value-type="YYYY"
            :disabled-date="(date) => date >= new Date()"
          ></date-picker>
        </b-form-group>

        <b-form-group label="Status" class="col-md-3">
          <multiselect
            v-model="selectSituacao"
            placeholder="Selecione"
            :show-labels="false"
            :options="optionSituacao"
            label="situacao"
          />
        </b-form-group>

        <b-form-group class="mt-3 col-md-12">
          <div class="d-flex justify-content-end">
            <div class="me-2 align-self-center mt-1">
              <b-button variant="primary" @click="filtrar()" class="m-1">
                <i
                  class="mdi mdi-filter-outline font-size-16 align-middle me-2"
                ></i>
                Filtrar
              </b-button>
            </div>

            <div div class="me-2 align-self-center mt-1">
              <b-button @click="limpar()">
                <i class="mdi mdi-broom font-size-16 align-middle me-2"></i>
                Limpar
              </b-button>
            </div>
          </div>
        </b-form-group>
      </div>
    </b-card>

    <b-card v-if="viewTabela">
      <div v-if="alerta" class="m-auto">
        <b-alert show :variant="variante"> {{ mensagem }} </b-alert>
      </div>
      <div>
        <div id="tickets-table_filter" class="dataTables_filter text-md-end">
          <label class="d-inline-flex align-items-center">
            <b-form-input
              v-model="filtro"
              type="search"
              placeholder="Pesquisar..."
              class="form-control form-control-sm ms-2"
            ></b-form-input>
          </label>
        </div>
      </div>
      <div class="table-responsive mb-0">
        <b-table
          class="datatables"
          responsive="sm"
          :items="veiculosFiltrado"
          :fields="campos"
          :filter="filtro"
          :per-page="perPage"
          :current-page="currentPage"
          show-empty
        >
          <template #empty>
            <h6 class="text-center">Nenhum resultado encontrado!</h6>
          </template>
          <template v-slot:cell(dt_ano_fabricacao)="data">
            {{ data.item.dt_ano_fabricacao.substr(0, 4) }}
          </template>
          <template v-slot:cell(ds_st_ativo)="data">
            <span
              class="badge badge-pill badge-soft-success font-size-11"
              :class="{
                'badge-soft-danger': data.item.st_ativo === 'N',
              }"
            >
              {{
                data.item.ds_st_ativo
                  .replace("Sim", "Ativo")
                  .replace("Não", "Inativo")
              }}
            </span>
          </template>
          <template v-slot:cell(actions)="data">
            <div class="button-items">
              <b-button
                class="mr-3"
                variant="success"
                @click.prevent="editar(data.item.nr_placa)"
                v-b-tooltip.hover
                title="Editar"
              >
                <i class="mdi mdi-pencil d-block font-size-11"></i>
              </b-button>
              <b-button
                variant="danger"
                @click="excluir(data.item)"
                v-b-tooltip.hover
                title="Excluir"
              >
                <i class="mdi mdi-trash-can d-block font-size-11"></i>
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import { required } from "vuelidate/lib/validators";
export default {
  components: {
    PageHeader,
    Multiselect,
    DatePicker,
  },
  data() {
    return {
      title: "Listagem de Veículos",
      alerta: false,
      filtro: "",
      variante: "",
      mensagem: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filterOn: [],
      veiculos: [],
      veiculosFiltrado: [],
      optionPlaca: [],
      optionMarca: [],
      optionModelo: [],
      optionCategoria: [],
      optionEmpresa: [],
      optionSituacao: [
        { situacao: "Ativo", value: "S" },
        { situacao: "Inativo", value: "N" },
      ],
      campos: [
        {
          key: "nr_placa",
          label: "Placa",
          sortable: true,
        },
        {
          key: "dt_ano_fabricacao",
          label: "Ano",
          sortable: true,
        },
        {
          key: "qt_km_inicial",
          label: "Hodômetro",
          sortable: true,
        },
        {
          key: "ds_st_ativo",
          label: "Status",
          sortable: true,
        },
        {
          key: "nm_marca",
          label: "Marca",
          sortable: true,
        },
        {
          key: "nm_modelo",
          label: "Modelo",
          sortable: true,
        },
        {
          key: "nm_categoria",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
        },
      ],
      dadosFiltro: {
        cd_pessoa: "",
        nr_placa: "",
        st_ativo: "",
        dt_ano_fabricacao: "",
        cd_marca: "",
        sq_modelo: "",
        cd_categoria: "",
      },
      selectFiltro: {
        marca: "",
        modelo: "",
        categoria: "",
        pessoa: "",
      },
      selectSituacao: "",
      dadosExcluir: {
        id: "",
        cdPessoa: "",
        cdTpPessoa: "",
        sqUsuario: "",
        nrPlaca: "",
        dtAnoFabricacao: "",
        kmInicial: "",
        stAtivo: "",
        cdCategoria: "",
        cdMarca: "",
        sqModelo: "",
        dsObs: "",
      },
      items: [
        {
          text: "Locadora",
          active: false,
        },
        {
          text: "Listagem de Veículos",
          href: "/locadora/veiculo",
        },
      ],
      viewTabela: false,
      submit: false,
    };
  },

  async created() {
    this.veiculos = await this.carregaLista();
    this.$http.get("api/veiculo/categoria").then((response) => {
      this.optionCategoria = response.data;
    });

    this.$http.get("api/veiculo/marca").then((response) => {
      this.optionMarca = response.data;
    });

    this.$http.get("api/veiculo/modelo").then((response) => {
      this.optionModelo = response.data;
    });

    this.$http.get("api/auth/buscarEmpresas").then((response) => {
      this.optionEmpresa = response.data;
      if (this.optionEmpresa.length == 1) {
        this.selectFiltro.pessoa = this.optionEmpresa[0];
        this.carregaPessoa();
      }
    });
    if (this.$store.state.notificacao) {
      this.$tools.alerta(
        this.$store.state.notificacao.notificacao,
        this.$store.state.notificacao.icone
      );
      this.$store.commit("ENVIAR_NOTIFICACAO", null); //Esvazia notificação
    }
  },

  computed: {
    rows() {
      return this.veiculosFiltrado.length;
    },
  },

  validations: {
    dadosFiltro: {
      cd_pessoa: {
        required,
      },
    },
  },

  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dadosFiltro[param].$invalid;
      } else {
        return null;
      }
    },

    editar(veiculo) {
      this.$router.push(`/locadora/veiculo/${veiculo}`);
    },

    excluir(veiculo) {
      Swal.fire({
        title: "Você tem certeza?",
        text: "Está ação não pode ser revertida!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sim, excluir registro!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.carregaDadosExcluir(veiculo);
          this.$http
            .delete("api/veiculo/" + this.dadosExcluir.id, {
              data: this.dadosExcluir,
            })
            .then(() => {
              this.veiculos = "";
              let indexVeiculo = this.veiculosFiltrado.findIndex(
                (el) => el.nr_placa == veiculo.nr_placa
              );
              this.veiculosFiltrado.splice(indexVeiculo, 1);
              this.montaMensagem("success", "Veiculo removido com sucesso");
            })
            .catch((error) => {
              this.montaMensagem("danger", error.response.data.message);
            })
            .then(() => {
              this.carregaLista();
            });
        }
      });
    },

    carregaLista() {
      return new Promise((resolve) => {
        this.$http.get("api/veiculo").then((response) => {
          resolve(response.data);
        });
      });
    },

    filtroSelect() {
      if (this.dadosFiltro.cd_categoria && this.dadosFiltro.cd_marca) {
        this.$http
          .get(
            "api/veiculo/modeloPorCategoriaAndMarca/" +
              this.dadosFiltro.cd_categoria +
              "/" +
              this.dadosFiltro.cd_marca
          )
          .then((response) => {
            this.optionModelo = response.data;
          });
      }
    },

    carregaDadosExcluir(veiculo) {
      this.dadosExcluir.id = veiculo.nr_placa;
      this.dadosExcluir.cdPessoa = veiculo.cd_pessoa;
      this.dadosExcluir.sqUsuario = veiculo.cd_pessoa;
      this.dadosExcluir.cdTpPessoa = veiculo.cd_tp_pessoa;
      this.dadosExcluir.nrPlaca = veiculo.nr_placa;
      this.dadosExcluir.cdCategoria = veiculo.cd_categoria;
      this.dadosExcluir.sqModelo = veiculo.sq_modelo;
      this.dadosExcluir.cdMarca = veiculo.cd_marca;
      this.dadosExcluir.dtAnoFabricacao = veiculo.dt_ano_fabricacao.substr(
        0,
        10
      );
      this.dadosExcluir.kmInicial = veiculo.qt_km_inicial;
      this.dadosExcluir.stAtivo = veiculo.st_ativo;
      this.dadosExcluir.dsObs = veiculo.ds_obs;
    },

    montaMensagem(variante, mensagem) {
      this.alerta = true;
      this.variante = variante;
      this.mensagem = mensagem;
    },

    carregaPlaca() {
      this.veiculos.forEach((item) => {
        if (item.cd_pessoa == this.dadosFiltro.cd_pessoa) {
          this.optionPlaca.push(item.nr_placa);
        }
      });
    },

    carregaMarca() {
      if (this.selectFiltro.marca) {
        this.dadosFiltro.cd_marca = this.selectFiltro.marca.cd_marca.toString();
        this.filtroSelect();
      } else {
        this.dadosFiltro.cd_marca = "";
      }
    },

    carregaCategoria() {
      if (this.selectFiltro.categoria) {
        this.dadosFiltro.cd_categoria =
          this.selectFiltro.categoria.cd_categoria.toString();
        this.filtroSelect();
      } else {
        this.dadosFiltro.cd_categoria = "";
      }
    },

    carregaModelo() {
      if (this.selectFiltro.modelo) {
        this.dadosFiltro.sq_modelo =
          this.selectFiltro.modelo.sq_modelo.toString();
      } else {
        this.dadosFiltro.sq_modelo = "";
      }
    },

    carregaPessoa() {
      if (this.selectFiltro.pessoa) {
        this.dadosFiltro.cd_pessoa =
          this.selectFiltro.pessoa.cd_pessoa.toString();
        this.carregaPlaca();
      } else {
        this.dadosFiltro.cd_pessoa = "";
        this.optionPlaca = [];
      }
    },

    filtrar() {
      this.submit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.viewTabela = false;
      this.veiculosFiltrado = "";
      this.veiculosFiltrado = this.veiculos;

      if (this.selectSituacao) {
        if (this.selectSituacao.value === "S") {
          this.dadosFiltro.st_ativo = "S";
        } else {
          this.dadosFiltro.st_ativo = "N";
        }
      } else {
        this.dadosFiltro.st_ativo = "";
      }

      this.veiculosFiltrado = this.veiculosFiltrado.filter((item) => {
        for (var key in this.dadosFiltro) {
          if (this.dadosFiltro[key] && this.dadosFiltro[key] !== item[key]) {
            return false;
          }
        }
        return true;
      });
      this.viewTabela = true;
    },

    limpar() {
      (this.dadosFiltro.nr_placa = ""),
        (this.dadosFiltro.nm_marca = ""),
        (this.dadosFiltro.nm_modelo = ""),
        (this.dadosFiltro.cd_categoria = ""),
        (this.dadosFiltro.dt_ano_fabricacao = ""),
        (this.dadosFiltro.st_ativo = ""),
        (this.dadosFiltro.sq_modelo = ""),
        (this.dadosFiltro.cd_marca = ""),
        (this.dadosFiltro.cd_pessoa = ""),
        (this.selectFiltro.pessoa = ""),
        (this.selectFiltro.categoria = ""),
        (this.selectFiltro.marca = ""),
        (this.selectFiltro.modelo = ""),
        (this.selectSituacao = ""),
        (this.viewTabela = false);
    },
  },
};
</script>

